/**
 * Contact form wiring.
 *
 * The form itself is rendered by Elements/parse_content/contactus.twig — the
 * engine substitutes it into a static page wherever the editor placed the
 * shortcode. The submit is core-common's `ContactForm` global, which attaches
 * the CSRF token and posts to the engine.
 *
 * base_neo's version of that twig loads ContactForm.js with its own <script
 * src> even though the file is already inside frameworks.min.js — so the class
 * is defined twice per page — and then inlines the wiring. Both are here
 * instead, once, in the bundle.
 */
import { qs, qsa } from './dom.js';

const t = (key) => (window.i18n && window.i18n[key]) || '';

export function setupContactForms() {
  const roots = qsa('[data-contact-form]');
  if (!roots.length) return;

  if (typeof window.ContactForm !== 'function') return;

  for (const root of roots) {
    const form = qs('form', root);
    const status = qs('[data-contact-status]', root);
    const submit = qs('button[type="submit"]', root);
    if (!form) continue;

    const say = (message, busy) => {
      if (status) status.textContent = message;
      if (submit) submit.disabled = Boolean(busy);
    };

    new window.ContactForm(form, {
      onSubmit: () => say(t('formSubmitting'), true),
      onSuccess: () => {
        say(t('formSubmitted'), false);
        form.reset();
      },
      onError: () => say(t('formSubmitFailed'), false),
    });
  }
}
